export const DATE_TIME_FORMAT = 'YYYY-MM-DD';

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];
export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
  'Day',
  'Weekday',
  'Weekend day'
];



// WEBPACK FOOTER //
// ./src/lib/constants/index.js